import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const DASHBOARD_MODULE_TABS = [
  { key: 'decision-engine', label: 'Karar Motoru', path: '/admin' },
  { key: 'segment-analysis', label: 'Segment Analizi', path: '/admin/segment-analysis' },
  { key: 'product-analytics', label: 'Ürün Analizi', path: '/admin/product-analytics' },
  { key: 'behavior-templates', label: 'Mesaj Şablonları', path: '/admin/behavior-templates' },
  { key: 'behavior-insights', label: 'Davranış İçgörüleri', path: '/admin/behavior-insights' },
  { key: 'behavior-metrics', label: 'Davranış Ölçümleri', path: '/admin/behavior-metrics' }
];

export const DASHBOARD_WORKSPACE_HIDDEN_PATHS = [
  '/admin/segment-analysis',
  '/admin/product-analytics',
  '/admin/behavior-templates',
  '/admin/behavior-insights',
  '/admin/behavior-metrics'
];

const MENU_GUIDE_BY_PATH = {
  '/admin': {
    title: 'Karar Motoru — admin ana ekranı',
    text: 'Buraya "bugün nelere bakmalıyım?" diye gelirsin. Sistemin o anki halini tek bakışta gösterir: kaç kullanıcı ne yapıyor, neyi kabul ediyor, nerede sorun/fırsat var ve bunun paraya etkisi ne. Burada bir şey YAPMAZSIN, durumu görürsün; detaya inmek için ilgili sekmeye geçersin.',
    examples: [
      'Kullanıcılar öneriyi beğeniyor ama pişirmiyorsa, bunu burada fark edersin.',
      'Hangi kullanıcı grubunda sorun ya da fırsat var, tek panelde görürsün.',
      '"Bir şeyler ters mi?" sorusunun ilk durağı burasıdır.'
    ]
  },
  '/admin/segment-analysis': {
    title: 'Segment Analizi — kullanıcılarına soru sor',
    text: 'Bir Excel pivot tablosu gibi düşün: kullanıcılarına soru sorup cevabı tablo olarak alırsın. Üç şey seçersin → (1) KİMLER: segment/chip (Bebekli, Premium, "Tüketti"…). (2) NE ÖLÇEYİM: metrik (Kullanıcı Sayısı, Kabul Oranı…). (3) NASIL PARÇALAYAYIM: kırılım (Yemek Tipi…). Çalıştır, cevabı oku. Aklında somut bir soru olunca anlamlı; yoksa boş görünür.',
    examples: [
      'Bebekli aileler en çok hangi yemeği tüketiyor? → Bebekli + "Tüketti" + Yemek Tipi kırılımı.',
      'Premium kullanıcılar planı daha çok mu tamamlıyor? → Premium + Plan Uyumu metriği.',
      'İpucu: en fazla 2 metrik seç — fazlası sonucu karmaşık gösterir.'
    ]
  },
  '/admin/product-analytics': {
    title: 'Ürün Analizi — tarifler nasıl gidiyor?',
    text: 'Ürün ve tariflerin performansını izlediğin yer. Hangi tarifler tutuyor, ilgi zamanla artıyor mu azalıyor mu, hangi tarif sorun üretiyor. "Ürün tarafında ne iyi, ne kötü gidiyor?" sorusu burada cevaplanır.',
    examples: [
      'Bir tarifin ilgisi haftalar içinde artıyor mu azalıyor mu, trende bak.',
      'Sorun üreten (eksik/uyumsuz çıkan) tarifleri yakala.',
      'Ürün tarafını haftada bir buradan gözden geçir.'
    ]
  },
  '/admin/behavior-templates': {
    title: 'Mesaj Şablonları — kullanıcıya ne mesaj gitsin?',
    text: 'Kullanıcılara giden bildirim/mesaj metinlerini buradan yönetirsin: yeni metin yazar, önizler, yayına alırsın. Ayrıca hangi mesajın tuttuğunu (en güçlü / en sorunlu / en etkili) görürsün. "Ne mesaj atalım ve işe yarıyor mu?" burada.',
    examples: [
      'Yeni bir hatırlatma metni yaz, önizle, yayına al.',
      'Hangi mesaj en çok tutmuş, hangisi sorunlu — karşılaştır.',
      'Bir mesajın kullanıma/paraya etkisini gör.'
    ]
  },
  '/admin/behavior-insights': {
    title: 'Davranış İçgörüleri — sistemin hazır cevapları',
    text: 'Segment Analizi\'nin "kendin sor" hali yorucuysa, burası "hazır cevap" halidir. Sistem senin için örüntüleri çıkarır ("şu grupta kabul yüksek ama pişirme düşük") ve önerilen aksiyonu, kaç kullanıcıyı etkileyeceğiyle birlikte sunar. Sen sadece okuyup karar verirsin.',
    examples: [
      'Hazır bir içgörüyü gör: "şu segmentte plan yapılıyor ama alışveriş tamamlanmıyor".',
      'Önerilen aksiyonun kaç kullanıcıyı etkileyeceğini gör.',
      'İçgörüden uygun aksiyona geç.'
    ]
  },
  '/admin/yardim': {
    title: 'Yardım — panelin rehberi',
    text: 'Bu sayfa tüm admin panelinin sade rehberidir: hangi sekme ne işe yarar, nereye ne zaman gidersin. Bir yerde takılırsan buraya dön.',
    examples: [
      '"Operasyon mu, analiz mi?" ayrımıyla başla.',
      '6 sekme tablosundan ilgili sekmeye tıkla.',
      '"Nereye gideyim?" tablosundan ihtiyacına göre git.'
    ]
  },
  '/admin/behavior-metrics': {
    title: 'Davranış Ölçümleri — sistemin nabzı',
    text: 'Sistemin sağlık göstergeleri ve ham sayıları. "Bir şey bozuldu mu (anomali), ölçümler tutarlı mı, akış adımları nasıl dönüşüyor?" — günlük operasyon değil, teknik nabız kontrolü. Çoğunlukla buraya sadece "her şey yolunda mı?" diye bakarsın.',
    examples: [
      'Son 24 saatte anormal bir sıçrama var mı, gör.',
      'Sistem durumu yeşil mi, tek bakışta kontrol et.',
      'Ölçümlerde tutarsızlık çıkarsa erken yakala.'
    ]
  }
};

export default function DashboardModuleTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openGuide, setOpenGuide] = React.useState(false);

  const activeGuide = MENU_GUIDE_BY_PATH[location.pathname] || MENU_GUIDE_BY_PATH['/admin'];

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-2 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex gap-2 overflow-x-auto pb-1">
          {DASHBOARD_MODULE_TABS.map((tab) => {
            const active = location.pathname === tab.path;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => navigate(tab.path)}
                className={`shrink-0 rounded-lg px-4 py-2 text-sm font-bold transition-all ${active
                  ? 'bg-primary text-white'
                  : 'border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-800 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={() => setOpenGuide(true)}
            className="rounded-lg border border-slate-200 px-3 py-2 text-xs font-bold text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
          >
            Bu Menü Nasıl Çalışır?
          </button>
          <button
            type="button"
            onClick={() => navigate('/admin/yardim')}
            className="flex items-center gap-1 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-xs font-bold text-primary hover:bg-primary/10"
          >
            <span className="material-symbols-outlined text-[16px]">help</span>
            Yardım
          </button>
        </div>
      </div>

      {openGuide ? (
        <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/60 p-4">
          <div className="max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-xl border border-slate-200 bg-white p-4 shadow-2xl dark:border-slate-700 dark:bg-slate-900">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h4 className="text-base font-black text-slate-900 dark:text-white">{activeGuide.title}</h4>
                <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{activeGuide.text}</p>
              </div>
              <button
                type="button"
                onClick={() => setOpenGuide(false)}
                className="rounded-md border border-slate-200 px-2 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
              >
                Kapat
              </button>
            </div>
            <div className="mt-4">
              <p className="text-sm font-bold text-slate-900 dark:text-white">Örnek Kullanım</p>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-700 dark:text-slate-200">
                {activeGuide.examples.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}
